export class CreateBankModel {
  public codigoBanco: string = ''
  public nome: string = ''
  public statusBanco: string | 'S' | 'N' = 'N'
}

export class EditBankModel {
  public id: number = 0
  public codigoBanco: string = ''
  public nome: string = ''
  public statusBanco: string | 'S' | 'N' = 'N'
}

export class DeleteBankModel {
  public id: number = 0
  public nome: string = ''
}

export class SearchBankModel {
  public nome: string = ''
}

export class CreateBankResponse {
  public response: any
}
export class EditBankResponse {
  public response: any
}
export class DeleteBankResponse {
  public response: any
}
export class PagedBankResponse {
  public response: any
}
